<template>
    <div>
        <div
            v-if="
                canInsertObject &&
                !showEdit &&
                !showObjectButtons
            "
        >
            <button :disabled="!canCreateOrEditObjects||editionEnabled||creationEnabled||!canCreateObject"
                @click="showCreationButtons"
                class="button is-white is-active lb-th-add-button"
            >
                <span class="icon"><i class="mdi mdi-32px mdi-plus-circle has-text-eduloc-grey-dark"></i></span>
            </button>
        </div>
        <div
            v-if="
                canInsertObject &&
                (showEdit || showObjectButtons)
            "
            v-click-outside.self="onClickOutside"
                    
        >
            <div v-for="option in availableObjects" :key="option">
                <button :disabled="!canCreateOrEditObjects||editionEnabled||creationEnabled||!canCreateObject"
                    class="button is-active is-1 lb-th-action-button is-rounded"
                    :class="buttonClasses(option)"
                    @click.stop="createObject(option)"
                >
                    <div class="button-content">
                        <span class="is-pulled-left">+ {{ $t(`App.${option}`) }}</span>
                        <span :data-tooltip="$t(`treasurehunt_${option}_helper`)" class="icon is-medium is-pulled-right has-tooltip-multiline has-tooltip-eduloc-blue">
                            <i class="mdi mdi-18px mdi-help-circle-outline has-text-white"></i>
                        </span>
                    </div>
                </button>
                
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import tippy from 'tippy.js';
export default {
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        trigger: {
            type: Object,
            default: () => {
                return {};
            },
        },
        availableObjects: {
            type: Array,
            default: () => {
                return [];
            },
        },
        showObjectButtons: {
            type: Boolean,
            default: false,
        },
        canCreateOrEditObjects: {
            type: Boolean,
            default: false,
        },
        editionEnabled: {
            type: Boolean,
            default: false,
        },
        creationEnabled: {
            type: Boolean,
            default: false,
        },
        hideButtons: {
            type: Boolean,
            default: false,
        },
        canCreateObject: { type: Boolean, default: false },
    },
    data() {
        return {
            showEdit: false,
        };
    },
    watch: {
        hideButtons: {
            handler() {
                if(this.showEdit){
                    this.showEdit = false;
                }
            },
        },
        
    },
    computed: {
        canInsertObject() {
            if (this.trigger.type == 'END') {
                return false;
            }
            return this.availableObjects.length;
        },
        
    },
    methods: {
        buttonClasses(option){
            switch(option){
                case "object":
                    return "is-eduloc-blue";
                case "question":
                    return "is-eduloc-orange";
                case "clue":
                    return "is-primary";
            }
            
        },
        onClickOutside(e) {
            if(this.creationEnabled){
                return;
            }
            if (this.showEdit) {
                this.showEdit = false;
            }
        },
        showCreationButtons(){
            if(!this.canCreateOrEditObjects||this.editionEnabled){
                return;
            }
            this.$emit("closeOthers",true);
            setTimeout(() => {
                this.showEdit = true;
            }, 200);
        },
        createObject(option) {
            if(!this.canCreateOrEditObjects||this.editionEnabled||this.creationEnabled||!this.canCreateObject){
            // if(!this.canCreateOrEditObjects||this.editionEnabled){
                return;
            }
            this.$emit('add', { type: option });
        },
    },
    mounted() {
       this.$nextTick(() => {  
            tippy('.newhelp',
                {
                    content: (reference) => reference.getAttribute('_title'),

                }
            );
        });
    },
};
</script>

<style scoped>
.lb-th-add-button {
    padding: 0;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    background-color: white;
}
.lb-th-action-button {
    margin: 0.2rem;
    width: 12rem;
    
}
.lb-th-action-button .button-content{
    width: 100%;
    padding: 0 0.5rem;
    font-family: var(--primary-font);
}
</style>
